import React from 'react';

const SplashScreen = () => {
  return <div>Loading</div>;
};
export default SplashScreen;
